import React from 'react'
import { P } from '@farewill/ui'
import { GTR } from '@farewill/ui/tokens'
import { PRODUCTS } from 'lib/products/constants'
import { RoleSection, RoleTemplate, RoleTitle, RoleUl } from '../RoleTemplate'

const ProbateQALead = (): React.JSX.Element => (
  <RoleTemplate
    roleName="Probate QA Lead"
    roleUrl="https://dignity.kallidusrecruit.com/vacancyinformation.aspx?vguid=aabff721-f55e-46c2-9c87-4526830d147d"
    location="Maidenhead (Hybrid – 3 days on-site)"
    salary="£45,000+ per annum (depending on experience)"
    contractType="Full-time, Permanent"
    closingDate="1st August 2025"
    product={PRODUCTS.PROBATE}
    content={
      <>
        <RoleSection margin={[GTR.M, 0]}>
          <RoleTitle>The Role</RoleTitle>
          <P>
            We help families through some of the hardest days of their lives. As
            part of the UK&apos;s leading end-of-life group, Dignity supports 1
            in every 8 families after a death, and increasingly, many of them
            need expert guidance on probate and estate administration.
          </P>
          <P>
            As we expand, we are looking for an experienced Probate QA Lead to
            ensure the highest possible standards in our probate work. You will
            play a key role in quality assurance, technical guidance, and
            operational excellence within our dedicated, compassionate team.
          </P>
          <P>
            This is a meaningful opportunity to use your expertise in a
            purpose-driven business that values technical skill, commercial
            understanding, and emotional intelligence.
          </P>
        </RoleSection>
        <RoleSection margin={[GTR.M, 0]}>
          <RoleTitle>Key Responsibilities</RoleTitle>
          <P>
            You will be responsible for technical operations and quality
            assurance in our probate work, including:
          </P>
          <RoleUl>
            <li>
              Reviewing and auditing files and documentation for compliance,
              accuracy, and service quality
            </li>
            <li>
              Providing technical advice to case handlers on complex matters
              concerning wills, executorships, trusts, and tax
            </li>
            <li>
              Supporting the operational team with process improvement, legal
              updates, and best practice guidance
            </li>
            <li>
              Supporting team members through training, knowledge-sharing, and
              technical upskilling
            </li>
            <li>
              Monitoring developments in UK probate, tax, and trust law, with
              particular attention to England & Wales, and a willingness to
              upskill in N. Ireland and Scottish jurisdictions as needed
            </li>
            <li>
              Collaborating with senior management to ensure the efficient,
              compliant delivery of our probate services
            </li>
            <li>
              Supporting the organisation in developing pragmatic, commercially
              minded solutions for complex estate situations
            </li>
            <li>
              Playing a critical part in internal audits and regulatory
              compliance reviews
            </li>
          </RoleUl>
        </RoleSection>
        <RoleSection margin={[GTR.M, 0]}>
          <RoleTitle>About You</RoleTitle>
          <RoleUl>
            <li>
              Professionally qualified as a Solicitor (England and Wales),
              CILEX, or have similar suitable work experience at a law firm
            </li>
            <li>
              Possess at least 5 years&apos; experience in probate,
              executorships, wills, tax and trusts
            </li>
            <li>
              Up-to-date technical knowledge of UK estate law, tax, and trusts
              (STEP or Association of Lifetime Lawyers - formerly SFE)
            </li>
            <li>Able to balance risk and practical outcomes</li>
            <li>
              A strong communicator able to advise, mentor, and train others,
              and work collaboratively across teams
            </li>
            <li>
              Diligent, composed under pressure, and unfailingly detail-focused
            </li>
            <li>
              Comfortable working both independently and within a
              high-performing team
            </li>
            <li>
              Able to adapt in a fast-paced environment and meet tight deadlines
            </li>
          </RoleUl>
        </RoleSection>
        <RoleSection margin={[GTR.M, 0]}>
          <RoleTitle>What We Offer</RoleTitle>
          <RoleUl>
            <li>Annual salary of £45,000 per annum</li>
            <li>25 Days Holiday + Bank Holidays</li>
            <li>X2 Life Assurance</li>
            <li>Pension Scheme</li>
            <li>Hybrid flexible working (3 days in our Maidenhead office)</li>
            <li>Genuine career progression and mentorship opportunities</li>
            <li>
              A chance to make a meaningful contribution to people&apos;s lives
              and deaths
            </li>
          </RoleUl>
        </RoleSection>
      </>
    }
  />
)

export default ProbateQALead
